'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiVendorMicrosoft = function TiVendorMicrosoft(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.7 20.8c0-0.5-0.4-0.8-0.9-0.8h-10c-0.5 0-0.8 0.3-0.8 0.8v8.4c0 0.5 0.3 0.8 0.8 1l10 1.1c0.5 0 0.9-0.3 0.9-0.6v-9.9z m2.5-0.8c-0.5 0-0.9 0.3-0.9 0.8v9.9c0 0.5 0.4 0.8 0.9 1l15 1.6c0.5 0 0.8-0.3 0.8-0.6v-11.7c0-0.5-0.3-0.8-0.8-0.8l-15-0.2z m-2.5-12.2c0-0.5-0.4-0.8-0.9-0.6l-10 1.1c-0.5 0-0.8 0.4-0.8 0.9v8.3c0 0.5 0.3 0.8 0.8 0.8h10c0.5 0 0.9-0.3 0.9-0.8v-9.7z m2.5-1c-0.5 0-0.9 0.5-0.9 1v9.9c0 0.5 0.4 0.8 0.9 0.8h15c0.5 0 0.8-0.3 0.8-0.8v-11.7c0-0.5-0.3-0.8-0.8-0.7l-15 1.5z' })
        )
    );
};

exports.default = TiVendorMicrosoft;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/vendor-microsoft.js
// module id = 3816
// module chunks = 0